module.exports = {
  name: 'complimentary-privileges',
  settings: {
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    mobileFirst: true,
    cssEase: 'linear',
    variableWidth: true,
  },
}
